'use strict';

var util = require('./util');

function enablePrivacyCookies() {
    var $trackingConsentBar = $('.c-tracking-consent');

    if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
        $trackingConsentBar.removeClass('ms-hide');
    } else {
        $trackingConsentBar.addClass('ms-hide');
    }
}

function checkPrivacyCookie() {
    var $cookieAcceptedButton = $('.c-tracking-consent__agree');
    var $trackingConsentBar = $('.c-tracking-consent');

    $cookieAcceptedButton.on('click', function() {
        acceptCookies();
        $trackingConsentBar.addClass('ms-hide');
    });

    setTimeout(function() {
        acceptCookies();
        $trackingConsentBar.addClass('ms-hide');
    }, 10000);
}

function acceptCookies() {
    $.ajax({
        type: 'GET',
        url: util.appendParamToURL(Urls.consentTrackingSetSession, 'consentTracking', true),
        success: function () {
            document.cookie = 'dw_cookies_accepted=1; path=/';
        }
    });
}

var consentTracking = {
    init: function () {
        if (SitePreferences.CONSENT_TRACKING_HINT) {
            enablePrivacyCookies();
            checkPrivacyCookie();
        }
    }
};

module.exports = consentTracking;
